import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState'; 
import AppSdk from 'kts-platform-frame/appSdk'; 
import ModulesState from './Modules.State';
import { Button, Input, Tooltip, Spin, Form, Select, TreeSelect } from 'antd'; 
import ModulesAction from './Modules.Action'; 
import { Urls } from 'kts-platform-frame/entry/constant';
import { create } from 'kts-scaffold-framework/utils/form'; 
import { MyStore, reducers } from 'kts-platform-frame/redux';
import ModulesRoute, { Switch } from './Modules.Route.List';
import { Link, Route } from 'react-router-dom';
import { history } from 'kts-platform-frame/routes';
import Test from './UI.Network.User.List.Detail';
const Search = Input.Search;
const Option = Select.Option; 
const { TextArea } = Input;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loading: any;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loading: state.system.loadingUrls, 
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    } 
    componentDidMount () {   
        /** 待加入列表 */
        // ModulesAction.pageListWaitingListAll({});
        /** 我的网络 */
        ModulesAction.pageListUsersListAll({});  
        // 获取标签列表
        ModulesAction.getCategoryAndTagData(); 
    }
    /** 组件被卸载时，关闭右侧弹窗 */
    componentWillUnmount () {
        ModulesAction.hideAside();
    } 
    render() { 
        const { sortList = [], list = [] } = this.modulesState.stateUserlist; 
        // const waitinglist = this.modulesState.stateUserWaitingjoinlist;
        const { getFieldDecorator } = this.props.form; 
        // const _noTag = [{
        //     title: '无标签',
        //     value: '-1',
        //     key: '-1', 
        //     label: '无标签'
        // }]; 
        // const treeData =  this.modulesState.tagData ? _noTag.concat(this.modulesState.tagData) : _noTag;
        // const tProps = {   
        //     placeholder: "请选择标签", 
        //     style:{fontSize: '12px'}, 
        //     dropdownStyle:{ maxHeight: 400, overflow: 'auto' },
        //     filterOption: (inputValue: string, option: any) => { return option.props.children.indexOf(inputValue) !== -1; }
        // };
        const _noTag = [{
            title: '无标签',
            value: '-1',
            key: '-1',  
            selectable: true,
        }]; 
        const treeData =  this.modulesState.tagData ? Array.prototype.concat(_noTag, this.modulesState.tagData) : _noTag;
        const tProps = {   
            treeData: treeData,
            placeholder: "标签", 
            style: {fontSize: '12px'}, 
            multiple: true,
            treeDefaultExpandAll: true,
            allowClear: true,
            treeNodeFilterProp: 'title',
            dropdownClassName:css.treeselecttick,
            dropdownStyle:{ maxHeight: 400, overflow: 'auto' },
            getPopupContainer:() =>  window.document.getElementById('biaoqianss2')
            // filterOption: (inputValue: string, option: any) => { return option.props.children.indexOf(inputValue) !== -1; }
        };
        return (
            <div className={`${css.usernetmodules} splirscrollbar borderradius`} > 
                    <div className={css.userleftside}>
                        <Form> 
                            <FormItem style={{marginBottom: 0}}>
                                <a className={css['userleftside-invite']} onClick={()=>{AppSdk.instance.openApp(this, 'Kingxunlian.NetworkMgmt');}} >+ 邀请企业</a>
                            </FormItem>
                            <FormItem style={{marginBottom: 0}}>
                                {getFieldDecorator('companyName',{ 
                                })(<Input placeholder="请输入名称查询" /> )}
                            </FormItem>
                            <FormItem style={{marginBottom: 0,}}>
                                <div id="biaoqianss2">
                                {getFieldDecorator('labelIds',{ 
                                })(
                                    <TreeSelect {...tProps} />    
                                    // <Select mode="multiple" {...tProps}>
                                    //     {treeData.map((item, index)=><Option key={index} value={item.value}>{item.title}</Option>)}
                                    // </Select>
                                )}
                                </div>
                            </FormItem>
                            <div> 
                                <Button 
                                    className="kts-but-primary"  
                                    loading={this.props.loading.has(Urls.userNetworkMyList)} 
                                    onClick={this.onSearchName} 
                                    style={{width: '100%',marginTop: '5px'}}
                                >
                                    搜索
                                </Button>
                            </div>
                        </Form>   
                    <div>   
                            <div className={`${css.myicontitle}`}>
                            <div className={css.myicontitle}><i className="anticon anticon-relationship"></i>  我的网络</div> 
                            </div>
                            <div style={{clear: 'both'}}></div>
                            <Spin spinning={this.props.loading.has(Urls.networkMyList)}>
                                {
                                    this.modulesState.waitinglistshow && sortList.map((itemclass, classindex) => {  
                                        return (
                                            <div className={css.letterclass} key={classindex}>
                                                <div className={css.letters}>{itemclass.letter.toUpperCase()}</div>
                                                {
                                                    itemclass.data.map((item, index) => {
                                                        return  (
                                                            <Tooltip key={index} title={item.connectionName}>
                                                                <div 
                                                                    onClick={this.onShowCompanyDetailModal.bind(this, item.connectionId)} 
                                                                    className={css.mynetworklist} 
                                                                    style={{cursor: 'pointer'}} 
                                                                    key={index}
                                                                >
                                                                    {item.connectionName}
                                                                </div>
                                                            </Tooltip>
                                                        );
                                                    })
                                                }
                                            </div>
                                        ); 
                                    })
                                }
                            </Spin>
                        </div>   
                        <div>
                            
                        </div> 
                    </div>
                    <div className={css.userrightside}>
                        <Switch>
                            {ModulesRoute.getChildReact()}
                        </Switch> 
                    </div> 
            </div>
        );
    }
     /** 查看详情 */
     private onShowCompanyDetailModal = (companyId) => {  
        history.push(`/workbench/platform/network/userlist/${companyId}`);
        ModulesAction.userNetworkCompayDetail(companyId);
    } 
    /** 重新邀请 */
    private onReInvitation = (record) => {
        ModulesAction.invitOneCompany({ 
            invitationCompanyName: record.invitationCompanyName,
            invitationEmail: record.contactEmail
        });
    }

    /** 更改公司备注 */
    private updateRemark = (e) => {
        e.preventDefault(); 
        this.props.form.validateFields((err, values) => { 
            if (!err) {
                ModulesAction.changeUserCompanyRemark(values); 
            }
        }); 
        // this.props.form.resetFields();
    }
    /** 按照名称模糊查询，待加入公司，我的网络 */
    private onSearchName = () => {  
        this.props.form.validateFields((err, values) => { 
            if (values.labelIds){
                values.labelIds = values.labelIds.map(item=> parseInt(item, 10));
            }
            ModulesAction.pageListUsersListAll({fuzzyConnectionName: values.companyName, labelIds:  values.labelIds});
            /** 这个接口好像没有再用了？ */
            // ModulesAction.pageListWaitingListAll({name: values.companyName}); 
        });
    }  

    private openCommercialInfo = () => {
        AppSdk.instance.openApp(this, {
            appKey: 'Kingxunlian.CommercialInfo',
            openType: 1,
            routing:'/',
            parameter: {
                taxId: this.modulesState.statePlatform.detail.taxId
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.User.List.tsx